import { Link } from "react-router-dom";
import dataApplicationsContext from '../context/dataApplicationsContext';
import { useContext } from 'react';

const ErrorUnauthorize = ({ error }) => {
  // const { openSideBar } = useContext(dataApplicationsContext);
  
  return (
    <div className={`bodyContainer`}>
      <div className="oops-container"  id="oops-401">
        <div className="oops-wrapper" id="oops-wrapper-404">
          <div className="oops-content pt-0">
            <div className="oops-text">
              <div className="oops-title">
                <h1>Oups !</h1>
              </div>
              <p>Désolé, Mais vous ne disposez pas les autorisations nécessaires pour cette page</p>
            </div>
            <Link to="/" className="oops-btn">Retour à l'accueil</Link>
          </div>
          <img src="/images/401-error.svg" alt="Error-404" className="img-error"></img>
        </div>
      </div>
    </div>
  )
}

export default ErrorUnauthorize